import { SearchProductResult, SearcProductRequest } from "@/types/productType";
import http from "./httpService";
import Cookies from "js-cookie";

export function getSearchProducts({
  text,
  relatedProductId,
  categoryId,
  skip,
  take,
  customerId,
  liked,
  mostDiscount,
  lastDiscount,
  mostVisited,
  mostSold,
  minPrice,
  maxPrice,
  fetchType,
  categoryIds,
  sortType,
  brandIds,
  sortOrder,
}: SearcProductRequest): Promise<SearchProductResult> {
  const token = Cookies.get("AccessToken");

  return http
    .post(
      `/ProductApi/GetSearchedProducts`,
      {
        text,
        relatedProductId,
        categoryId,
        skip,
        take,
        customerId,
        liked,
        mostDiscount,
        lastDiscount,
        mostVisited,
        mostSold,
        minPrice,
        maxPrice,
        fetchType,
        categoryIds,
        sortType,
        sortOrder,
        brandIds,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then(({ data }) => data.data);
}
